<template>
  <div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
    <div style="padding: 15px;">
      <van-cell-group>

        <div style="text-align: center; background-color: #fff; padding: 20px;">{{school_name}}</div>
        <div style="height: 50px;"></div>
        <van-field v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" />
        <van-field v-model="stuForm.exam_num" label="考试证号" placeholder="请输入考试证号" />
        <div style="height: 50px;"></div>
        <div class="submitBtn flexAround">
          <div class="btn" @click="onSearch" style="width: 40%;">录取查询</div>
        </div>
        <div style="height: 50px;"></div>
      </van-cell-group>
    </div>

  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import {
  Dialog,
  Toast
} from 'vant';
export default {

  data() {
    return {
      school_name: "",
      pmid: 0,
      openid: "",
      stuForm: {
        stu_name: "",
        archive: "",
      },
    }
  },
  mounted() {
    $(".page").height($(window).height())
    document.title = "请完善您的信息"
    this.pmid = this.$route.query.pmid
    this.openid = this.$route.query.openid

    window.pmid = this.pmid

    this.getSchoolName();
    this.getStudents()

  },
  methods: {
    getSchoolName() {
      this.$http.post("/api/app_platform_info", {
        pmid: this.pmid
      }).then(res => {
        this.school_name = res.data.platform
      })
    },
    getStudents() {

      this.$http.post("/api/stuinfo_byopenid", {
        pmid: this.pmid,
        openid: this.openid
      }).then(res => {
        if (res.data.type == 'luqu') {
          if (res.data.stu) {
            console.log('redirectTo',res.data.stu)
            console.log('redirectTo',wx)
            wx.miniProgram.redirectTo({
              url: '/pages/moreFun/bd/bd'
            })
          } else {
            Toast("该生已登记，但还未被录取！.");
            this.showSearch = true
          }
        } else if (res.data.type == 'baoming') {
          Toast("该生已登记，但还未被录取！！");
          if (res.data.stu) {
            this.stuForm = res.data.stu
          }
          this.showSearch = true
        }else{
          this.showSearch = true
        }
      })

      //
    },

    onSearch() {

      this.$http.post("/api/app_luqu_check", {
        stu_name: this.stuForm.stu_name,
        stu_code: this.stuForm.exam_num,
        pmid: this.pmid,
        openid: this.openid
      }).then(res => {
        if (res.data.id && res.data.status >= 3) {
          if (res.data.stu_name && (res.data.stu_name.trim() == this.stuForm.stu_name.trim())) {
            //绑定当前用户
            if (this.openid) {
              this.bindWX(res.data.id)
            } else {
              Toast("请重新扫码进入操作")
            }
          }
        } else if (res.data.id && res.data.status < 3) {
          Toast("该生已登记，但还未被录取！");
        } else {
          Toast("未找到录取信息！");
        }

      })
    },
    bindWX(id){
      let _this = this
      Dialog.alert({
        title: "提示",
        message: '已查询到考生信息，是否与该微信号绑定？若不与该微信号绑定，请点击取消；切换微信号后，重新扫码进入该页面。',
        messageAlign: 'left',
        showCancelButton: true,
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        confirmButtonColor: '#00cfdc',
      }).then(() => {
        console.log("点击了继续按钮噢")
        this.$http.post("/api/bind_stu_openid", {
          id: id,
          pmid: this.pmid,
          openid: this.openid
        }).then(ok => {
          wx.miniProgram.redirectTo({
            url: '/pages/moreFun/bd/bd'
          })
        })

      }).catch(() => {
        console.log("点击了取消按钮噢")
      })
    }

  },
}
</script>

<style lang="less" type="text/less">
.van-radio__icon {
  font-size: 16px;
}

.van-radio__icon--checked .van-icon {
  background-color: #00cfdc;
  border-color: #00cfdc;
}
.submitBtn {
  margin-top: 2vh;
  margin-bottom: 50px;

  .btn {
    display: inline-block;
    padding: 1.4vh 8%;
    background-color: #00CFDC;
    color: #fff;
    font-size: 15px;
    border-radius: 5vw;
    width: 50%;
    text-align:center;
  }
  .btn:active {

    background-color: #007AFF;

  }
}
.imagebox{ border:1px dotted #ccc; width: 100px; height: 100px; background-color: #F2F3F5; display: flex; align-items: center;justify-content: center; font-size: 40px; color:#ccc}
</style>
